import styled from 'styled-components'

export const Surface = styled.div`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.line};
  border-radius: 1.25rem;
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.04),
    0 12px 28px -16px rgba(15, 23, 42, 0.10);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  isolation: isolate;
`

export default Surface
